/** SetpageWz 기본값 — /start_wz body와 동일 키 */
export function getDefaultWzStartSettings() {
  return {
    entry_mode: 'kinpoint',
    first_usdt: 10,
    leverage_info: 20,
    entry_standard: 'disable',
    entry_signal: 'ut',
    ema_standard: 200,
    ema_losscut: 'no',
    ema_entry_gap_ratio: 0,
    entry_standard_type: 'haikin',
    entry_standard_candle: '4h',
    sensitivity_standard: 2,
    atr_period_standard: 2,
    sensitivity: 2,
    atr_period: 2,
    sensitivity_close: 1,
    atr_period_close: 1,
    profit: 1,
    losscut: 1.5,
    entry_candle: '5m',
    add_position: 2,
    single_double_benefit: 'double',
    benefit_standard: 'kinpoint',
    add_signals: 'ut',
    entry_checking: -1,
    standard_checking: -1,
    benefit_checking: -1,
    ma_1st: 3,
    ma_2nd: 6,
    ma_3rd: 9,
    rsi_length: 7,
    low_rsi: 30,
    high_rsi: 70,
    mix_candle: '1h',
    close_candle: '15m',
    direction: 'both',
    min_benefit_ratio: 0.3,
    both_benefit_ratio: 0.3,
    mix_benefit: 0.35,
    mix_benefit_reentry: 'off',
    occurrence_losscut: 'off',
    total_benefit_usdt: 0,
    entry_usdt_1: 10,
    entry_usdt_2: 10,
    entry_usdt_3: 10,
    entry_usdt_4: 0,
    entry_usdt_5: 0,
    entry_usdt_6: 0,
    entry_usdt_7: 0,
    entry_usdt_8: 0,
    entry_usdt_9: 0,
    entry_ratio_1: 3,
    entry_ratio_2: 3,
    entry_ratio_3: 3,
    entry_ratio_4: 0,
    entry_ratio_5: 0,
    entry_ratio_6: 0,
    entry_ratio_7: 0,
    entry_ratio_8: 0,
    entry_ratio_9: 0,
    entry_usdt_add_1: 10,
    entry_usdt_add_2: 10,
    entry_usdt_add_3: 10,
    entry_usdt_add_4: 0,
    entry_usdt_add_5: 0,
    entry_usdt_add_6: 0,
    entry_usdt_add_7: 0,
    entry_usdt_add_8: 0,
    entry_usdt_add_9: 0,
    entry_ratio_add_1: 3,
    entry_ratio_add_2: 3,
    entry_ratio_add_3: 3,
    entry_ratio_add_4: 0,
    entry_ratio_add_5: 0,
    entry_ratio_add_6: 0,
    entry_ratio_add_7: 0,
    entry_ratio_add_8: 0,
    entry_ratio_add_9: 0,
    candle_type_entry: 'haikin',
    candle_type_close: 'haikin',
  };
}

export function mergeWzStartSettings(prev, patch) {
  if (!patch || typeof patch !== 'object') {
    return prev;
  }
  return { ...prev, ...patch };
}

/** SetpageWz add_position 에 따른 동적 라벨 */
export function getWzEntryUILabels(addPosition) {
  const ap = addPosition;
  if (ap === 1 || ap === '1') {
    return {
      candleText: '맥스KP익절 기준봉',
      setTextLong: '맥스 셋팅',
      setTextShort: '',
      showLongEntryGrid: true,
      showShortEntryGrid: false,
      longTitleClass: 'red-text',
      shortTitleClass: 'blue-text',
    };
  }
  if (ap === 0 || ap === '0') {
    return {
      candleText: '진입 시간봉',
      setTextLong: '',
      setTextShort: '오리지널 셋팅',
      showLongEntryGrid: false,
      showShortEntryGrid: true,
      longTitleClass: 'red-text',
      shortTitleClass: 'blue-text',
    };
  }
  return {
    candleText: '진입 시간봉',
    setTextLong: '롱진입 셋팅',
    setTextShort: '숏진입 셋팅',
    showLongEntryGrid: true,
    showShortEntryGrid: true,
    longTitleClass: 'red-text',
    shortTitleClass: 'blue-text',
  };
}

export const WZ_ENTRY_ROW_LABELS = ['1st', '2nd', '3rd', '4th', '5th', '6th', '7th', '8th', '9th'];
